export default __webpack_public_path__ + "static/media/10.e44bd4cf.jpg";